/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Popconfirm,
  Avatar,
  Layout,
  Table,
  Tag,
  Input,
  Switch,
} from "antd";
import {
  ALL_PRODUCT,
  DELETE_PRODUCT,
  EDIT_STATUS_PRODUCT,
  IMAGE_BASE_URL,
} from "../../constants/api";
import { CURRENCY } from "../../constants/constent";

function ProductTable() {
  const { Content } = Layout;
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    getData();
  }, []);

  const updateStatus = (values) => {
    setLoading(true);
    const jsonData = {
      id: values.id,
      status: values.status,
    };

    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getData();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Update Data");
    };
    postAPI(EDIT_STATUS_PRODUCT, jsonData, successFn, errorFn);
  };

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        const rData = data["data"].map((row, index) => ({
          key: index,
          ID: index + 1,
          Name: row.product_name,
          Price: `${CURRENCY} ${row.product_amt}`,
          Category_n: row.product_category.title,
          Category: <Tag color="processing">{row.product_category.title}</Tag>,
          Image: (
            <Avatar.Group shape="square">
              {row.product_images.map((item) => (
                <Avatar
                  shape="square"
                  src={IMAGE_BASE_URL + item.image.filePath}
                />
              ))}
            </Avatar.Group>
          ),
          Active: (
            <Tag color={`${row.status === 1 ? "green" : "error"}`}>
              {row.status === 1 ? "Active" : "Disabled"}
            </Tag>
          ),
          Action: (
            <Space>
              <Switch
                loading={loading}
                disabled={loading}
                defaultChecked={row.status === 1}
                onChange={(e) => updateStatus({ id: row.id, status: e })}
              />
              <Button
                loading={loading}
                disabled={loading}
                onClick={() => {
                  navigate("/product/edit/" + row.id);
                }}
                block
              >
                Edit
              </Button>
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={() => deleteData(row.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button loading={loading} disabled={loading} danger>
                  Delete
                </Button>
              </Popconfirm>
            </Space>
          ),
        }));
        setState(rData);
        setFilteredData(rData);
        setLoading(false);
      } else {
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };
    getAPI(ALL_PRODUCT, successFn, errorFn, {});
  };

  const deleteData = (values) => {
    setLoading(true);
    let data = {
      id: values,
    };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getData();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_PRODUCT, data, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (room) =>
        room.Name.toLowerCase().includes(value.toLowerCase()) ||
        room.Category_n.toLowerCase().includes(value.toLowerCase()) ||
        room.Price.toString().includes(value)
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
      width: 50,
    },
    {
      title: "Image",
      dataIndex: "Image",
      width: 50,
    },
    {
      title: "Category",
      dataIndex: "Category",
      width: 50,
    },
    {
      title: "Name",
      dataIndex: "Name",
      width: 150,
    },
    {
      title: "Price",
      dataIndex: "Price",
      width: 150,
    },
    {
      title: "Order Enable",
      dataIndex: "Active",
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "Action",
      width: 100,
    },
  ];

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Manage Product"
            extra={
              <Space>
                <Input
                  placeholder="Search by Name or Category"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
                <Button onClick={() => navigate("/product/add")}>
                  Add <PlusOutlined />
                </Button>
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}

export default ProductTable;
